import cs from 'classnames';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { narratives } from './constants';
import styles from './index.module.scss';

type INarrativeCard = {
  narrative: string;
  setNarrative: (val: string) => void;
  onSwiperInit?: (swiper: any) => void;
};

const NarrativeCard = forwardRef<any, INarrativeCard>(
  ({ narrative, setNarrative, onSwiperInit }, ref) => {
    const swiperRef = useRef<any>(null);

    // Swiper imports
    // @ts-ignore
    // eslint-disable-next-line
    const { Swiper, SwiperSlide } = require('swiper/react');
    require('swiper/css');

    useImperativeHandle(ref, () => ({
      slideNext: () => swiperRef.current?.slideNext(),
      slidePrev: () => swiperRef.current?.slidePrev(),
      slideTo: (idx: number) => swiperRef.current?.slideTo(idx),
    }));

    return (
      <div className={styles['card']}>
        <Swiper
          spaceBetween={24}
          slidesPerView={'auto'}
          onSwiper={(swiper: any) => {
            swiperRef.current = swiper;
            if (onSwiperInit) onSwiperInit(swiper);
          }}>
          {narratives.map((item, index) => (
            <SwiperSlide key={index} style={{ width: '167px' }}>
              <div
                className={cs([
                  styles['narrative_card'],
                  item.voice === narrative ? styles['active'] : '',
                ])}
                onClick={() => setNarrative(item.voice)}>
                <div className={styles.image_container}>
                  <img src={item.image} alt={`narrative-${item.voice}`} />
                </div>
                <span className={styles['title']}>{item.voice}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  },
);

export default NarrativeCard;
